import styled from 'styled-components'
import { GRAY, WHITE, PURPLE, LIGHT_PURPLE, HOVER_BLUE } from 'constants/colors'
import { Flex } from '../styles'

export const RadioIcon = styled.span`
  border-radius: 16px;
  width: 16px;
  height: 16px;
  border: 1px solid ${GRAY};
  background-color: ${WHITE};
`

export const RadioCheckedIcon = styled(RadioIcon)<{ color: string }>`
  background-color: ${({ color }) => color};
  box-shadow: none;

  &:before {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: ${WHITE};
    content: '';
  }
`

export const RadioContainer = styled(Flex)<{ color: string }>`
  .MuiRadio-root {
    padding: 2px;

    &.Mui-checked {
      .MuiIconButton-label {
        > span {
          border-color: ${({ color }) => color};
        }
      }
    }

    &:hover {
      .MuiIconButton-label {
        > span {
          box-shadow: 0 0 3px
            ${({ color }) => (color === PURPLE ? LIGHT_PURPLE : HOVER_BLUE)};
        }
      }

      .MuiIconButton-label {
        > span {
          border-color: ${({ color }) => color};
        }
      }
    }
  }
`
